export default {
    STEP_VALUE: 25,
};



// WEBPACK FOOTER //
// ./src/constants/slider.js